export default "__VITE_ASSET__fffdd1ab__"